import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useLogin from "../../../../custom-hooks/useLogin";
import "./SubscriptionMainBanner.scss";
import _ from "lodash";
import ShimmerScreen from "../../../Layouts/ShimmerScreen";
import VideoPlayer from "react-video-js-player";

const SubscriptionMainBanner = () => {
  const { isLoggedIn, subscribedData } = useLogin();

  const subscriptionPlan = useSelector(
    (state) => state.subscription.subscriptionPlan
  );

  const [tagLine, setTagLine] = useState(
    "Everything Real Estate Agents Need to Learn, Grow, and Succeed"
  );

  useEffect(() => {
    if (!_.isEmpty(subscribedData)) {
      if (!_.isEmpty(subscriptionPlan)) {
        if (subscriptionPlan.status === "success") {
          let planList = subscriptionPlan.payload.data;
          if (!_.isEmpty(planList)) {
            planList = _.sortBy(planList, "weightage");
            for (let [index, plan] of planList.entries()) {
              if (plan.id === subscribedData.ecom_sub_id) {
                console.log("PLAN DATA", plan);
                if (planList[index + 1]) {
                  let planName = planList[index + 1].title;
                  setTagLine(
                    `Get more out of Xsel with the ${planName} subscription.`
                  );
                  break;
                }
              }
            }
          }
        }
      }
    }
  }, [subscribedData, subscriptionPlan]);

  const onPlayerReady = (player) => {
    player.src("");
    // let videoData = videoDetailInfo[0];
    // player.src({
    //   src: videoData.video_link,
    //   withCredentials: true,
    // });
    const trackEl = player.addRemoteTextTrack(
      {
        // src: videoData?.subtitle_url,
        kind: "captions",
        srclang: "en",
        label: "English",
      },
      false
    );
    trackEl.addEventListener("load", function () {});
    window.scrollTo(0, 50);
  };

  return (
    <>
      <section className="subs-bannersection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="banner-content">
                <h1 className="sub-page-title">
                  {tagLine ? (
                    tagLine
                  ) : (
                    <div className="d-flex gap-3 flex-column align-items-center">
                      <ShimmerScreen case="rect" width="100%" height="2rem" />
                      <ShimmerScreen case="rect" width="80%" height="2rem" />
                    </div>
                  )}{" "}
                </h1>
                <p className="subs-title">
                Master real estate at your own pace with Xsel’s comprehensive learning platform. Gain access to foundational courses, an extensive video library, and monthly live webinars with industry experts. Enjoy exclusive offers, discounts on select courses like NAR certification and NIIT, plus rewards and coaching services. With interactive roleplays, technical support, and AI-driven learning, Xsel ensures you're equipped with the tools to succeed. Learn on your terms and elevate your career today!
                </p>
              </div>
              <div className="video-sec-subsc">
                {/* <iframe
                  src={"https://www.youtube.com/embed/p4J-MbXOaqE"}
                  title={"Real Estate Video"}
                  height="516"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  width="100%"
                /> */}
                 {/* <VideoPlayer
              className="img-videosec learn_image-card"
              controls={true}
              src={"https://rsplearning-dev.niit-mts.com/meeting/images/617527938043218.mp4"}
              width="100%"
              height="516"
              autoPictureInPicture={true}
              // poster={!showLearnMore ? item?.product_thumbnail : ""}
              fluid={true}
              inline={false}
              pictureInPictureToggle={true}
              type={"video/mp4"}
              onReady={onPlayerReady}
              crossorigin="use-credentials"
            /> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SubscriptionMainBanner;
